import React, { forwardRef } from "react";
import classnames from "classnames";

import {
  Input as SharedInput,
  InputProps as SharedInputProps,
} from "@sportal/cdk/input/Input";
import { useIntlTranslate } from "../../hooks";

import "./Input.scss";

export enum InputSize {
  Small = "small",
  Medium = "medium",
}

const classModifierMap = {
  [InputSize.Small]: "input--small",
  [InputSize.Medium]: "input--medium",
};

interface InputProps extends SharedInputProps {
  inputSize?: InputSize;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  {
    className,
    inputSize = InputSize.Medium,
    maxLength,
    showLimit = true,
    autoComplete = "off",
    ...props
  },
  ref
) {
  const translate = useIntlTranslate();

  return (
    <SharedInput
      ref={ref}
      className={classnames(className, classModifierMap[inputSize])}
      showLimit={showLimit && maxLength > 0}
      maxLength={maxLength}
      autoComplete={autoComplete}
      clearButtonAriaLabel={translate("aria_clear_input_data")}
      {...props}
    />
  );
});
